export default class Elevator {
    id = null;
    isPrivate = false;
    active = false;
    test = false;
    name = '';
    description = '';
    deviceId = null;
    mac = '';
    address = '';
    zip = '';
    city = '';
    country = 0;
    province = null;
    impressionClass = 0;
    latitude = 0.0;
    longitude = 0.0;
    version = '';
    channel = '';
    tags = [];
    blackTags = [];
    customer = null;
    emergencyCenter = null;
    buildingType = 0;
    value = '';
    mediaId = null;
    remoteNumber = '';
    pcvisit = '';
    emergencyContactList = [];
    emergencyPhoneNumber = '';
    dataPhoneNumber = '';
    offlineMail = false;
    demo = false;
    camera = false;
    technicianName = '';
    technicianPhone = '';
    advertCalculation = '';
    monthlyCost = 0.0;
    resolutionWidth = 0;
    resolutionHeight = 0;
    contractStart = null;
    contractEnd = null;
    sponsorStart = null;
    sponsorEnd = null;
    processingFee = 0.0;
    iccidEmergency = '';
    iccidData = '';
    serialnumberTablet = '';
    serialnumberBlackbox = '';
    serialnumberCamera = '';
    serialnumberComputer = '';
    operatingSystem = '';
    externEmergencyId = '';
    externEmergencyInfo = '';
    advertisingBonus = false;
    advertisingContract = '';
    urlBackground = '';
    urlLogo = '';
    buttonContent = null;
    additionalElevators = [];
    vhost = 'VIMA';
    options = [];

    constructor() {
    }
}
